module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isAjax && _vm.nowMessageList) ? _c('mu-list', _vm._l((_vm.nowMessageList), function(item, index) {
    return _c('div', {
      key: index,
      ref: "child",
      refInFor: true,
      class: [{
        swipeleft: _vm.isSwipe[index]
      }, 'wrap'],
      on: {
        "click": function($event) {
          return _vm.getActiveId_x(item._id)
        }
      }
    }, [_c('mu-list-item', {
      staticClass: "list-item",
      attrs: {
        "title": item.friend.name,
        "describeLine": 1,
        "disableRipple": true
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": item.friend.avatar
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      staticStyle: {
        "color": "rgba(0, 0, 0, .5)"
      }
    }, [_vm._v(_vm._s(item.list[item.list.length - 1].message))])]), _vm._v(" "), _c('div', {
      staticClass: "item-right",
      attrs: {
        "slot": "right"
      },
      slot: "right"
    }, [_c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.list[item.list.length - 1].time))]), _vm._v(" "), _c('mu-badge', {
      attrs: {
        "content": ("" + (item.list.length-1))
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeM(item._id)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71bf5544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/message.vue
// module id = 519
// module chunks = 1